import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {Box, Divider, Skeleton} from '@mui/material';
import {AppCard} from 'components/card';

export const TimerCardSkeleton = () => {
    return (
        // <AppCard sx={{width: '100%', borderRadius: 2, marginBottom: '10px'}}>
        //     <Box display="flex" alignItems="center" justifyContent="space-between">
        //         <Box display="flex" alignItems="center" gap={1}>
        //             <AccessTimeIcon color="primary" />
        //             <Box>
        //                 <Skeleton variant="text" width={160} height={20} />
        //                 <Skeleton variant="text" width={200} height={18} />
        //             </Box>
        //         </Box>
        //         <AppIconButton>
        //             <Skeleton variant="circular" width={24} height={24} />
        //         </AppIconButton>
        //     </Box>
        //     <Skeleton variant="text" width={200} height={20} sx={{mt: 2}} />
        // </AppCard>

        <AppCard style={{marginBottom: '10px'}}>
            <Box display="flex" justifyContent={'space-between'} pb={'5px'}>
                <Box display="flex" alignItems="center" gap={1}>
                    <AccessTimeIcon color="primary" style={{fontSize: '30px'}} />
                    <Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Skeleton variant="text" width={160} height={20} />
                        </Box>
                        <Skeleton variant="text" width={200} height={18} />
                    </Box>
                </Box>
                <Box>
                    <Skeleton variant="rounded" width={50} height={30} />
                </Box>
            </Box>
            <Divider sx={{mb: 1}} />

            <Skeleton variant="text" width={200} height={20} sx={{mt: 2}} />
        </AppCard>
    );
};
